import { render } from "./list-rrids.vue?vue&type=template&id=aed00f14"
import script from "./list-rrids.vue?vue&type=script&lang=js"
export * from "./list-rrids.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__